import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

export const EndNode = memo((props: NodeProps) => {
  const { id, data } = props;

  return (
    <div className={'node end'} title="Click here to add Action">
      End
      <Handle className={'handle'} type="target" position={Position.Top} isConnectable={false} />
    </div>
  );
});
